module.exports = __webpack_public_path__ + "static/media/icon-module-operational-panel-desktop.52998c43.svg";